module.exports = __webpack_public_path__ + "static/media/Rahul Dhingra.33d00865.png";